export const WHATSAPP_NUMBER = "917861917281"; // +91 78619 17281
export const WHATSAPP_MESSAGE =
  "Hi SuperAge Health, I'd like to book a Precision Liver Evaluation.";

export const whatsappLink = (msg = WHATSAPP_MESSAGE) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const CITIES = ["Ahmedabad", "Surat", "Vadodara"];
export const PHONE_DISPLAY = "78619 17281";
export const WEBSITE = "www.superagehealth.com";
